import { Component, EventEmitter, forwardRef, Injector, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RequestService } from 'src/app/core/service/request.service';

export const INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide:NG_VALUE_ACCESSOR,
  useExisting: forwardRef(()=> EnumSelectComponent),
  multi: true
};

@Component({
  selector: 'app-enum-select',
  templateUrl: './enum-select.component.html',
  styleUrls: ['./enum-select.component.css'],
  providers: [INPUT_CONTROL_VALUE_ACCESSOR]
})
export class EnumSelectComponent implements OnInit,ControlValueAccessor {
  @Input() multiple: boolean = false;
  @Input() placeholder: string = '';
  @Input() noDataText: string = '';
  @Input() searchText: string = '';
  @Input() DefaultFirst = false;
  @Input() enumName: string;
  @Output() onSelectedChange: EventEmitter<any> = new EventEmitter();
  @Input() disabled: boolean = false;
  @Input() filter: (data:any) => boolean;
  @ViewChild('select', {static:true}) select : any;

  private fetched: boolean = false;
  public innerValue: any;
  public IsDisabled: boolean = false;
  public items: any[] = [];
  public event: () => void;
  public onTouchedCallback: ()=> void = () => {};
  public onChangeCallback: (_: any)=> void = (_: any) => {};

  get value(): any{
    return this.innerValue;
  }

  set value(v: any){
    if(v != this.innerValue)
    {
      this.innerValue = !this.isNull(v)? v: null;
      this.onChangeCallback(this.innerValue);
    }
  }
  constructor(
    public http: RequestService,
    public injector: Injector
  ) { 
    //super(injector);
  }

  ngOnInit(): void {
    this.send();
  }
  
  ngOnChanges(simple: SimpleChanges){
    if(simple["enumName"] && simple["enumName"].currentValue)
    {
      this.send((res:any) => this.items = this.filter != null? res.items.filter(this.filter):res.items);
    }
  }

  onChange($event:any){
    this.onSelectedChange.emit($event? $event:null);
  }

  writeValue(obj: any): void {
    if(this.fetched)
    {
      if(obj != this.innerValue){
        this.innerValue = !this.isNull((obj)? obj : null);
      }
    }else{
      this.event = () =>{
        if(obj != this.innerValue){
          this.innerValue = !this.isNull((obj)? obj : null);
        }
      }
    }
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  isNull(obj: any) {
    return obj == null || obj === undefined;
  }

  send(cb?: (res: any) => void){
    let _cb = cb? cb:((res: any)=>{
      this.items = this.filter != null?res.items.filter(this.filter):res.items;
      this.fetched = true;
      this.event && this.event();
    }).bind(this);

    this.http.Post("Common/GetEnumType",{"enumName":this.enumName}).subscribe(_cb);
  }
}
